<template>
  <b-card v-if="rows.length > 0" class="mb-4" header="Summary by doctor (OMA)">
    <b-table :items="rows" :fields="fields" striped hover responsive small class="mb-0">
      <template #cell(total_billed)="d">
        {{ formatMoney(d.value) }}
      </template>
      <template #cell(avg_total)="d">
        {{ formatMoney(d.value) }}
      </template>
      <template #cell(avg_np)="d">
        {{ formatMoney(d.value) }}
      </template>
      <template #cell(avg_nc)="d">
        {{ formatMoney(d.value) }}
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { BCard, BTable } from 'bootstrap-vue'

export default {
  name: 'SummaryByDoctor',
  components: { BCard, BTable },
  props: {
    datarda: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      fields: [
        { key: 'doctor_id', label: 'OMA ID', sortable: true },
        { key: 'doctor_name', label: 'Doctor', sortable: true },
        { key: 'patients_count', label: 'Patients', sortable: true },
        { key: 'total_billed', label: 'Total billed', sortable: true },
        { key: 'avg_total', label: 'Avg total', sortable: true },
        { key: 'np_count', label: 'NP #', sortable: true },
        { key: 'avg_np', label: 'Avg NP', sortable: true },
        { key: 'np_30_count', label: 'NP $30 #', sortable: true },
        { key: 'nc_count', label: 'NC #', sortable: true },
        { key: 'avg_nc', label: 'Avg NC', sortable: true },
        { key: 'nc_30_count', label: 'NC $30 #', sortable: true },
      ],
    }
  },
  computed: {
    rows() {
      const raw = this.datarda?.SUMMARY_BY_DOCTOR
      return Array.isArray(raw) ? raw : []
    },
  },
  methods: {
    formatMoney(value) {
      const n = Number(value)
      if (Number.isNaN(n)) return value ?? '—'
      return n.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
  },
}
</script>
